define('collections/Podio.Collections.Contacts',['require','underscore','jquery','lib/backbone/Backbone.PodioCollection','lib/Podio.Config','lib/Podio.Routes','models/Podio.Models.Contact'],function(require) {

  var _ = require('underscore');
  var $ = require('jquery');
  var PodioCollection = require('lib/backbone/Backbone.PodioCollection');
  var Config = require('lib/Podio.Config');
  var routes = require('lib/Podio.Routes');

  return PodioCollection.extend({

    url: '/contacts',

    configure: function() {
      this.model = require('models/Podio.Models.Contact');
    },

    filterByUserIds: function(userIds) {
      return this.filter(function(model) {
        return _.include(userIds, model.get('user_id'));
      });
    },

    getContactsByUserIds: function(userIds) {
      // The collection works as a cache of user profiles
      // The result will be a deferred which will be the filtered contacts based
      // on the input

      var unresolvedUserIds = _.difference(userIds, this.map(function(contact) {
        return contact.get('user_id');
      }));

      // We can resolve own profile using the Config
      if (_.contains(unresolvedUserIds, Config.user.user_id)) {
        this.add(this.model.getOwn());
        unresolvedUserIds = _.without(unresolvedUserIds, Config.user.user_id);
      }

      var dfd = new $.Deferred();
      if (unresolvedUserIds.length) {
        // We need to fetch some more profiles
        var userIdsParam = unresolvedUserIds.join(',');
        this.url = routes.get_contacts_by_user_ids_path(userIdsParam);

        var self = this;
        // Fetch while keeping existing contacts for caching
        this.fetch({
          remove: false,
          success: function() {
            dfd.resolve(self.filterByUserIds(userIds));
          }
        });
      } else {
        // We have all the profiles, so we can resolve directly
        dfd.resolve(this.filterByUserIds(userIds));
      }

      return dfd;
    }

  });

});

